var map = {
	"./albin.jpeg": 32,
	"./alexandra.jpeg": 33,
	"./background-dark.png": 34,
	"./background-light.png": 35,
	"./coral-reef.jpg": 36,
	"./emma.jpeg": 37,
	"./fanny.jpeg": 38,
	"./felix.jpeg": 39,
	"./filip.png": 40,
	"./hoffe.JPG": 41,
	"./johanna.JPG": 42,
	"./karolin.png": 43,
	"./kristina.jpg": 44,
	"./lelle.jpeg": 45,
	"./martin.jpeg": 46,
	"./my.jpg": 47,
	"./nlg-logo.png": 48,
	"./rasmus.JPG": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;